export const locale = {
  lang: 'fr-CA',
  data: {
    CREATE_COMBO_DYNAMIC: {
      TITLE: 'Nouveau Combo dynamique',
      SELECT_TYPE: 'Sélectionner un type de produit',
      FOOD: 'Nourriture',
      DRINK: 'Boisson',
    },
  },
};
